if (!customElements.get("custom-selectbutton")) {
    class CustomSelectButton extends HTMLElement {
        constructor() {
            super();
        }

        close() {
            this.classList.remove("is-open");
        }

        handleSort(element) {
            const filterSort = this.closest("[data-filter-sort]");
            if (!filterSort) return;
            filterSort.changeSortBy(element.dataset.value);
        }

        handleChange(element) {
            this.current.innerHTML = element.innerHTML;
            if (this.hasAttribute("data-sort")) this.handleSort(element);
            if (element.dataset.type == "url")
                this.closest("ajax-variant")?.update(element.dataset.value);
            this.querySelector(".is-active")?.classList.remove("is-active");
            element.classList.add("is-active");
            console.log('> custom-selectbutton: is active = ', element);
            this.close();
        }

        handleSellingPlansButtons(element) {
            if (document.querySelector('#purchaseTypeSubscription')) {
                if (document.querySelector('#purchaseTypeSubscription').checked) {
                    setTimeout(function () {
                        document.querySelector('#purchaseTypeSubscription').click()
                    }, 500);
                }
            }
        }

        handleSubscriptionOptions(element) {
            const el = jQuery(element);
            if (el && el.length) {

                let idRef = el.attr('data-id');

                let delivery = {
                    '1': 'Delivered every 1 month',
                    '2': 'Delivered every 3 month',
                    '3': 'Delivered every 6 month'
                }

                jQuery('.buy-once-button').hide();
                jQuery('.buy-once-button[data-id-ref="' + idRef + '"]').show();
                jQuery('.rtx-subscription-dropdown').attr('data-auto-select-by-name', delivery[idRef]);

                if (jQuery('.rtx-subscription').length) {
                    document.querySelector('.product__submit[type="submit"]').classList.add('loading');
                }

                setTimeout(function () {
                    jQuery('#purchaseTypeSubscription').trigger('click');
                }, 550);

            }

        }


        handleOptionChange(element) {
            console.log('handleOptionChange');
            const loopPurchaseOptionOneTime = document.querySelector('.loop-widget-purchase-option-onetime');
            const loopPurchaseOptions = document.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-label');



            console.log(element);

            this.updateOOSSelect(element);
            this.handleChange(element);
            // this.handleSubscriptionOptions(element)
            this.closest("product-form")?.update(element);
            setTimeout(() => {
                if (loopPurchaseOptions.innerHTML == 'One-time purchase') {
                    console.log('loopPurchaseOptionssss---s', loopPurchaseOptions.innerHTML);

                    loopPurchaseOptionOneTime.click();
                }
            }, 5);
        }

        handleQuantityChange(element) {
            this.handleChange(element);
            this.closest("product-form")?.updateQuantity(element.dataset.value);
        }

        updateCard(element) {
            this.card = this.closest(".js-product-card");
            if (!this.card) return;

            this.updatePrice(element);
            this.card.querySelector("cart-add")?.update(element);

            this.updateImage(element);
        }

        updateOOSSelect(element) {
            console.log('updateOOSSelect');
            let index = element.dataset;
            let thisID = index.id;
            // let klaviyoNotify = document.querySelector('.product__actions .notify');
            // let klaviyoBtn = document.querySelector('.product__actions .klaviyo-bis-trigger');
            let addToCartBtn = document.querySelector('.product__submit');
            let delayMessage = document.querySelector('div.delay');
            let rechargeWidget = document.querySelector('.rc-widget-injection-parent');
            console.log('thisID ', thisID);
            if (thisID) {
                let variantIventoryQty = document.querySelector('ul.inventory-available span[data-index="' + thisID + '"]');
                console.log('variantIventoryQty ', variantIventoryQty);

                if (variantIventoryQty && variantIventoryQty.dataset.inventoryQty) {
                    // Inventory is 0 or less
                    if (variantIventoryQty.dataset.inventoryQty <= 0) {
                        console.log('variant inventory qty is 0 or less');

                        // Check if this is allowed to be sold when sold out
                        if (variantIventoryQty.dataset.value.toLowerCase() !== 'continue') {
                            // Less than 0 in stock and marked to stop selling when out of stock
                            console.log('variant sold out and do no keep selling');
                            // klaviyoNotify.classList.remove('d-none');
                            // klaviyoBtn.style.display = 'flex';
                            // addToCartBtn.classList.add('d-none');
                            // delayMessage.classList.remove('d-none');
                            // if( rechargeWidget ){
                            //   rechargeWidget.classList.add('d-none');
                            // }
                            addToCartBtn.innerText = 'Out of Stock';
                            addToCartBtn.setAttribute('disabled', 'disabled');
                            addToCartBtn.disabled = true;

                        }
                        else {
                            // Continue selling
                            console.log('variant sold out but keep selling');
                            // klaviyoNotify.classList.add('d-none');
                            // klaviyoBtn.style.display = 'none';
                            if (document.getElementById('flavor_selector_type')) {
                                if (document.getElementById('flavor_selector_type').value !== 'Lemon Sips') {
                                    addToCartBtn.innerText = 'Add to Cart';
                                    addToCartBtn.classList.remove('d-none');
                                    addToCartBtn.removeAttribute('disabled');
                                }
                            }
                            delayMessage?.classList.add('d-none');
                            if (rechargeWidget) {
                                rechargeWidget.classList.remove('d-none');
                            }

                        }

                    }
                    // Variant is in stock
                    else {
                        console.log('variant in stock keep selling');

                    }

                }
            }
        }

        updatePrice(element) {
            this.price = this.card.querySelector(".js-price");
            this.price.innerHTML = element.dataset.price;
        }

        updateImage(element) {
            let index = element.dataset;
            console.log('element ', element)
            if (index.value) {
                console.log('element index.value ', index.value)
                let variantImgData = document.querySelector('ul.variant-images .span-wrap[data-value="' + index.value + '"]');
                console.log('variantImgData ', variantImgData)
                if (variantImgData && variantImgData.dataset.variantImg && document.querySelector('.product__media .swiper-slide-active img')) {
                    document.querySelector('.product__media .swiper-slide-active img').srcset = variantImgData.dataset.variantImg;
                }
            }

        }

        connectedCallback() {
            this.current = this.querySelector(".js-current");
            setTimeout(() => {
                console.log('init variant image switch')
                this.updateImage(this.current);
            }, 100);


            if (!this.current) return;

            document.body.addEventListener("click", () => {
                this.close();
            });

            this.addEventListener("drag", (event) => {
                event.stopPropagation();
            });

            this.addEventListener("click", (event) => {
                event.stopPropagation();

                document.querySelectorAll("custom-selectbutton").forEach((element) => {
                    if (element.classList.contains("is-open")) element.close();
                });
                let targetElement = document.querySelector('.span-wrap[data-id="' + event.target.dataset.id + '"]');
                console.log('event.target.dataset.id ', event.target.dataset.id);
                console.log('targetElement ', targetElement);
                if (event.target.dataset.price) this.updateCard(event.target);
                // Update Image on Variant Change
                this.updateImage(event.target);
                // Update Inventory on Variant Change
                // this.updateOOSSelect(event.target);
                if (this.dataset.type == "quantity" && event.target.dataset.value)
                    return this.handleQuantityChange(targetElement);
                if (event.target.dataset.index)
                    return this.handleOptionChange(targetElement);
                if (event.target.dataset.variantId || event.target.dataset.value)
                    return this.handleChange(targetElement);
                // this.classList.toggle("is-open");
            });
        }
    }
    customElements.define("custom-selectbutton", CustomSelectButton);
}
